import {defineStore} from 'pinia'
import {useUserStore} from "@/stores/user";
import router from "@/router";
import dayjs from "dayjs";
export const useStatsStore = defineStore('stats', {
    // a function that returns a fresh state
    state: () => ({
        items: [],
        loading: false,
        from: dayjs().startOf('year').valueOf(),
        to: dayjs().valueOf(),
        interval: '1w',
    }),
    // optional getters
    getters: {},
    // optional actions
    actions: {
        apiIndex() {
            const kdnr = useUserStore().user.organisation.kdnr || router.currentRoute.value.query.kdnr;
            return this.apiClientV2.get(`/stats?kdnr=${kdnr}`)
        },
        fetchData(name, {
            from,
            to,
            products,
            interval,
        } = {}) {
            this.loading = true
            const requestFrom = from ?? this.from
            const requestTo = to ?? this.to
            const requestInterval = interval ?? this.interval
            return this.apiClientV2.get(`/stats/${name}/from/${requestFrom}/to/${requestTo}/product/${products}/interval/${requestInterval}`)
                .finally(() => {
                    this.loading = false
                })
        },
    },
})
